import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const CatalogClients = () => {
  const { activeTenant } = useTenant();
  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({ name: '', nif: '', email: '', address: '' });

  const loadClients = () => {
    if (!activeTenant) return;
    api.get(`/catalog/clients?tenant_id=${activeTenant}`)
      .then((res) => setClients(res.data || []))
      .catch(() => toast.error('Error al cargar clientes'));
  };

  useEffect(() => {
    loadClients();
  }, [activeTenant]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.name || !formData.nif) {
      toast.error('Nombre y NIF son requeridos');
      return;
    }
    try {
      await api.post('/catalog/clients', { ...formData, tenant_id: activeTenant });
      toast.success('Cliente registrado');
      setFormData({ name: '', nif: '', email: '', address: '' });
      loadClients();
    } catch (error) {
      toast.error('Error al guardar cliente');
    }
  };

  const handleDelete = async (clientId) => {
    try {
      await api.delete(`/catalog/clients/${clientId}`);
      toast.success('Cliente eliminado');
      loadClients();
    } catch (error) {
      toast.error('Error al eliminar cliente');
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="catalog-clients">
      <div>
        <h1 className="text-3xl font-heading font-bold">Clientes a facturar</h1>
        <p className="text-muted-foreground">Registra clientes del tenant seleccionado.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Nuevo cliente</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <Label>Nombre *</Label>
              <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </div>
            <div>
              <Label>NIF *</Label>
              <Input value={formData.nif} onChange={(e) => setFormData({ ...formData, nif: e.target.value })} />
            </div>
            <div>
              <Label>Email</Label>
              <Input value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Label>Direccion</Label>
              <Textarea value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} />
            </div>
            <div className="md:col-span-2">
              <Button type="submit">Guardar cliente</Button>
            </div>
          </form>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Clientes registrados</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {clients.length === 0 ? (
            <div className="px-6 py-6 text-sm text-muted-foreground">No hay clientes registrados.</div>
          ) : (
            clients.map((client) => (
              <div key={client.id} className="flex items-center justify-between px-6 py-4 border-b last:border-b-0">
                <div>
                  <div className="font-medium">{client.name}</div>
                  <div className="text-xs text-muted-foreground">{client.nif}</div>
                </div>
                <Button variant="ghost" size="sm" onClick={() => handleDelete(client.id)}>
                  Eliminar
                </Button>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CatalogClients;
